export default Object.freeze({
  ALL: 'ALL',
  NO_VOTES: 'NO_VOTES',
  YOUR_VOTES: 'YOUR_VOTES',
  VOTE_NEEDED: 'VOTE_NEEDED',
  CONFLICTS: 'CONFLICTS',
  SCREENED: 'SCREENED',
});
